import { useState } from "react";
import { api } from "../../lib/api";
import { t } from "../../lib/i18n";
import { toast } from "sonner";
import { Field, Modal, Select } from "./_shared";

export default function DecksAdmin({ decks, components, players, refresh }) {
  const [form, setForm] = useState(null);
  const blades = components.filter((c) => c.type === "blade");
  const ratchets = components.filter((c) => c.type === "ratchet");
  const bits = components.filter((c) => c.type === "bit");
  const empty = { name: "", archetype: "Balanced", description: "", blades: ["", "", ""], ratchets: ["", "", ""], bits: ["", "", ""], owner_player_id: "" };

  const save = async () => {
    try {
      const payload = { ...form, owner_player_id: form.owner_player_id || null };
      if (form.id) await api.put(`/admin/decks/${form.id}`, payload);
      else await api.post(`/admin/decks`, payload);
      toast.success(t.saved);
      setForm(null);
      refresh();
    } catch (_) { toast.error(t.failed); }
  };
  const remove = async (id) => {
    if (!window.confirm(t.confirmDelete)) return;
    await api.delete(`/admin/decks/${id}`);
    toast.success(t.deleted);
    refresh();
  };

  return (
    <div className="mt-8">
      <button onClick={() => setForm(empty)} data-testid="new-deck-btn"
        className="px-5 py-2.5 bg-[#FF0055] hover:bg-[#FF3377] text-white font-bold uppercase tracking-[0.25em] text-xs">
        {t.newDeck}
      </button>
      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {decks.map((d) => (
          <div key={d.id} className="border border-white/10 bg-[#0C0C14] p-4 flex justify-between">
            <div className="min-w-0">
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#FF0055] font-bold">{d.archetype}</div>
              <div className="font-display font-bold uppercase italic text-xl mt-1 truncate">{d.name}</div>
            </div>
            <div className="flex flex-col gap-1 text-[10px] uppercase tracking-[0.25em] font-bold flex-shrink-0">
              <button onClick={() => setForm({ ...d, blades: [...d.blades, "", "", ""].slice(0, 3), ratchets: [...d.ratchets, "", "", ""].slice(0, 3), bits: [...d.bits, "", "", ""].slice(0, 3) })} className="text-white/70 hover:text-[#00E5FF]">{t.edit}</button>
              <button onClick={() => remove(d.id)} className="text-[#FF0055]">{t.delete}</button>
            </div>
          </div>
        ))}
      </div>

      {form && (
        <Modal title={form.id ? t.editDeck : t.newDeck} onClose={() => setForm(null)}>
          <div className="grid grid-cols-2 gap-3">
            <Field label={t.componentName} value={form.name} onChange={(v) => setForm({ ...form, name: v })} />
            <div>
              <label className="text-[10px] uppercase tracking-[0.25em] font-bold text-white/40">{t.archetype}</label>
              <select value={form.archetype} onChange={(e) => setForm({ ...form, archetype: e.target.value })}
                className="w-full bg-transparent border border-white/15 px-3 py-2 mt-1 text-sm focus:outline-none focus:border-[#00E5FF]">
                {["Attack", "Defense", "Stamina", "Balanced"].map((a) => <option key={a} className="bg-[#0C0C14]">{a}</option>)}
              </select>
            </div>
            <div className="col-span-2">
              <label className="text-[10px] uppercase tracking-[0.25em] font-bold text-white/40">{t.ownedBy}</label>
              <select value={form.owner_player_id || ""} onChange={(e) => setForm({ ...form, owner_player_id: e.target.value })}
                className="w-full bg-transparent border border-white/15 px-3 py-2 mt-1 text-sm focus:outline-none focus:border-[#00E5FF]">
                <option className="bg-[#0C0C14]" value="">— {t.none} —</option>
                {players.map((p) => <option key={p.id} className="bg-[#0C0C14]" value={p.id}>{p.handle}</option>)}
              </select>
            </div>
            <div className="col-span-2">
              <label className="text-[10px] uppercase tracking-[0.25em] font-bold text-white/40">{t.description}</label>
              <textarea rows={2} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })}
                className="w-full bg-transparent border border-white/15 px-3 py-2 mt-1 text-sm focus:outline-none focus:border-[#00E5FF]" />
            </div>
            {[0, 1, 2].map((i) => (
              <div key={i} className="col-span-2 grid grid-cols-3 gap-2 border border-white/10 p-3">
                <div className="col-span-3 text-[10px] uppercase tracking-[0.25em] font-bold text-[#FF0055]">{t.bey} {i + 1}</div>
                <Select label={t.blade} value={form.blades[i]} options={blades}
                  onChange={(v) => { const arr = [...form.blades]; arr[i] = v; setForm({ ...form, blades: arr }); }} />
                <Select label={t.ratchet} value={form.ratchets[i]} options={ratchets}
                  onChange={(v) => { const arr = [...form.ratchets]; arr[i] = v; setForm({ ...form, ratchets: arr }); }} />
                <Select label={t.bit} value={form.bits[i]} options={bits}
                  onChange={(v) => { const arr = [...form.bits]; arr[i] = v; setForm({ ...form, bits: arr }); }} />
              </div>
            ))}
          </div>
          <div className="flex justify-end gap-2 mt-5">
            <button onClick={() => setForm(null)} className="px-4 py-2 text-xs uppercase tracking-[0.25em] font-bold text-white/60">{t.cancel}</button>
            <button onClick={save} data-testid="save-deck-btn"
              className="px-5 py-2 bg-[#FF0055] hover:bg-[#FF3377] text-white font-bold uppercase tracking-[0.25em] text-xs">{t.save}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
